<template>
  <div>
    <transition name="modal">
      <div class="modal-mask modal-mask-height">
        <div class="modal-wrapper">
          <div class="modal-dialog ">
            <div>
              <div
                class="modal-content modal-width  padding-content deletePopup"
              >
                <div class="col-12 mt-2 mr-b10">
                  <h4 class="modal-title text-center"> {{ msg }}</h4>
                  <p class="headingText text-center"
                    >All services and inquiries associated with this vendor will
                    be permanently deleted</p
                  >
                </div>
                <!-- services Information -->
                <div class="col-12">
                  <DxDataGrid
                    ref="deleteVendorId"
                    :data-source="gridInformation"
                    :show-borders="true"
                    :hover-state-enabled="true"
                    :remote-operations="false"
                    :allow-column-reordering="false"
                    :row-alternation-enabled="false"
                    :column-hiding-enabled="true"
                    key-expr="ServiceRequestFormId"
                    :show-column-lines="true"
                    :show-row-lines="true"
                    @optionChanged="isLastPage"
                  >
                    <DxGroupPanel :visible="false" />
                    <DxSearchPanel
                      :visible="false"
                      :highlight-case-sensitive="true"
                    />

                    <DxGrouping :auto-expand-all="true" />
                    <DxPager
                      :allowed-page-sizes="[2, 5]"
                      :show-page-size-selector="true"
                      :show-info="true"
                      :show-navigation-buttons="true"
                    />
                    <DxPaging :page-size="2" />
                    <DxColumn
                      data-field="ServiceRequestFormName"
                      caption="Service Name"
                      cell-template="ServiceRequestFormNameTemplate"
                      :allow-sorting="true"
                      :width="250"
                    />
                    <div
                      slot="ServiceRequestFormNameTemplate"
                      slot-scope="{ data }"
                    >
                      <h6> {{ data.ServiceRequestFormName }} </h6>
                    </div>
                    <DxColumn
                      data-field="ServiceRequestFormId"
                      caption="Inquiries"
                      alignment="center"
                      cell-template="ServiceRequestFormEnquiriesTemplate"
                      :allow-sorting="true"
                    />
                    <div
                      slot="ServiceRequestFormEnquiriesTemplate"
                      slot-scope="{ data }"
                      class="center-align"
                    >
                      <h6>
                        {{ data.ServiceRequestFormEnquiries.length }}
                      </h6>
                    </div>
                  </DxDataGrid>
                </div>

                <div class="col-12 text-center ">
                  <div class="m-btn-wrap mr-t15 mr-b10">
                    <button
                      type="submit"
                      data-toggle="modal"
                      data-target="#requestModal"
                      class="rdBtn btnst getFont"
                      @click="agreeFlagFunction(true)"
                    >
                      Yes
                    </button>
                    <button
                      id="2"
                      data-dismiss="modal"
                      class="whtBtn btnst cursor-pointer getFont"
                      @click="agreeFlagFunction(false)"
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <loader v-if="loading"></loader>
    <popup v-if="showModal" :msg="postMessage" @response="sendResponse"></popup>
  </div>
</template>
<script>
import {
  superAdminMethods,
  superAdminComputed,
  providerMethods,
  providerComputed,
} from '@state/helpers'
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.compact.css'
import '@/public/css/devExtremeGridCssModified.css'
import loader from '@views/loader'
import popup from '@views/popup'
import {
  DxDataGrid,
  DxColumn,
  DxPager,
  DxPaging,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  // DxHeaderFilter,
  // DxFilterRow,
} from 'devextreme-vue/data-grid'
export default {
  components: {
    loader,
    popup,
    DxDataGrid,
    DxColumn,
    DxPager,
    DxPaging,
    DxSearchPanel,
    DxGrouping,
    DxGroupPanel,
  },
  props: {
    msg: String,

    vendorIdForDeletion: Number,
  },
  data() {
    return {
      loading: false,
      showModal: false,
      postMessage: '',
      hideFlag: false,
      vendorInformation: null,
      vendorDeletedSuccessfully: false,
      gridInformation: [],
      allInquires: [],
      allFacilities: [],
      allServiceImages: [],
      allServices: [],
      allVendorImages: [],
      allVendorCategory: [],
      allserviceproducts: [],
      allserviceQuetions: [],
      allservicechoices: [],
    }
  },

  computed: {
    ...superAdminComputed,
    ...providerComputed,
  },
  created() {
    this.vendorSearch()
  },

  methods: {
    ...superAdminMethods,
    ...providerMethods,
    isLastPage(pagination) {},
    // -------------------------------------------------------------------------------------------------------
    // Function to fetch all dependencies associated with Vendor Table
    async vendorSearch() {
      try {
        this.loading = true
        this.hideFlag = false
        var response = await this.loadVendor_BLK({
          vendorId: this.vendorIdForDeletion,
        })
        this.vendorInformation = response
        this.gridInformation = this.vendorInformation.ServiceRequestForms
        console.log(
          'vendorSearch -> this.vendorInformation',
          this.vendorInformation
        )
        this.loading = false
        this.hideFlag = true
      } catch (error) {
        console.log('vendorSearch -> error', error.message)
        this.postMessage = 'Internet is disconnected'
        this.showModal = true
        this.loading = false
      }
    },
    // -------------------------------------------------------------------------------------------------------
    // Function to Delete Inquires associated with the services
    async deleteEnquiry_BLK() {
      return new Promise((resolve, reject) => {
        var i = 0
        console.log('deleteEnquiry -> i', i)
        if (this.allInquires.length === 0) resolve('success')
        this.allInquires.forEach(async (element) => {
          try {
            await this.deleteEnquiries_BLK({
              data: element,
            })
            i = i + 1
            if (i === this.allInquires.length) resolve('success')
          } catch (error) {
            reject(error)
          }
        })
      })
    },
    // -------------------------------------------------------------------------------------------------------
    // Function to Delete buildings associated with the services
    deletionOfFacilityBuilding_BLK() {
      return new Promise((resolve, reject) => {
        var i = 0
        console.log('deletionOfFacilityBuilding_BLK -> i', i)
        if (this.allFacilities.length === 0) resolve('success')
        this.allFacilities.forEach(async (element) => {
          try {
            await this.deleteBuildingLinkingFromTable_BLK({
              Id: element,
            })
            i = i + 1
            if (i === this.allFacilities.length) resolve('success')
          } catch (error) {
            reject(error)
          }
        })
      })
    },
    // -------------------------------------------------------------------------------------------------------
    // Function to Delete Images associated with the services
    deletionOfImages_BLK() {
      return new Promise((resolve, reject) => {
        if (this.allServiceImages.length === 0) resolve('success')
        var i = 0
        console.log('deletionOfImages_BLK -> i', i)
        this.allServiceImages.forEach(async (element) => {
          try {
            await this.deleteImagesFromService_BLK({
              Id: element,
            })
            i = i + 1
            if (i === this.allServiceImages.length) {
              resolve('success')
            }
          } catch (error) {
            reject(error)
          }
        })
      })
    },
    // -------------------------------------------------------------------------------------------------------
    // Function to Delete all services
    async deleteService_BLK() {
      return new Promise((resolve, reject) => {
        var i = 0
        console.log('deleteService_BLK -> i', i)
        if (this.allServices.length === 0) resolve('success')
        this.allServices.forEach(async (element) => {
          try {
            await this.deleteParticularService_BLK({
              ServiceFormID: element,
            })
            i = i + 1
            if (i === this.allServices.length) resolve('success')
          } catch (error) {
            reject(error)
          }
        })
      })
    },
    // -------------------------------------------------------------------------------------------------------
    // Function to Delete images associated with the vendor
    async deleteVendorMedia() {
      return new Promise((resolve, reject) => {
        if (this.allVendorImages.length === 0) {
          resolve('success')
        } else {
          var i = 0
          console.log('deletionOfImages_BLK -> i', i)
          this.allVendorImages.forEach(async (element) => {
            try {
              await this.deleteImagesFromProviderMedia_BLK({
                Id: element,
              })
              i = i + 1
              if (i === this.allVendorImages.length) {
                resolve('success')
              }
            } catch (error) {
              reject(error)
            }
          })
        }
      })
    },
    // -------------------------------------------------------------------------------------------------------
    // Function to Delete categories associated with the vendor
    async deleteVendorCategory() {
      return new Promise((resolve, reject) => {
        if (this.allVendorCategory.length === 0) {
          resolve('success')
        } else {
          var i = 0
          console.log('deletionOfImages_BLK -> i', i)
          this.allVendorCategory.forEach(async (element) => {
            try {
              await this.deleteCategoryFromProviderCategoryMappings_BLK({
                Id: element,
              })
              i = i + 1
              if (i === this.allVendorCategory.length) {
                resolve('success')
              }
            } catch (error) {
              reject(error)
            }
          })
        }
      })
    },
    // -------------------------------------------------------------------------------------------------------
    // Function to Delete Vendor
    async deleteVendorFromDatabase(providerId) {
      console.log('deleteVendorFromDatabase -> providerId', providerId)
      try {
        this.loading = true
        var response = await this.deleteVendor_BLK({
          providerID: providerId,
        })
        console.log('deleteVendorFromDatabase -> response', response)

        this.loading = false
        if (
          response.status === '200' ||
          response.status === 200 ||
          response.status === '201' ||
          response.status === 201
        ) {
          this.postMessage = 'Vendor deleted successfully'
          this.vendorDeletedSuccessfully = true
        } else {
          this.postMessage = 'Try again'
        }
        this.showModal = true
      } catch (error) {
        this.loader = false
        this.postMessage = 'Try again'
        this.showModal = true
      }
    },
    // -------------------------------------------------------------------------------------------------------
    // Function to Created array for deletion Using ID
    getRelevantInformation() {
      this.loading = true
      this.allInquires = []
      this.allFacilities = []
      this.allServiceImages = []
      this.allServices = []
      this.allVendorImages = []
      this.allVendorCategory = []
      this.allserviceproducts = []
      this.allservicechoices = []
      this.allserviceQuetions = []
      console.log(
        'this.vendorInformation.ServiceRequestForms :',
        this.vendorInformation.ServiceRequestForms
      )

      this.vendorInformation.ServiceRequestForms.forEach((element) => {
        element.ServiceRequestFormEnquiries.forEach((element1) => {
          this.allInquires.push(element1.Id)
        })
        element.ServiceRequestFormFacilityLinks.forEach((fac) => {
          this.allFacilities.push(fac.ServiceRequestFormFacilityLinkId)
        })
        element.ServiceRequestFormsImages.forEach((im) => {
          this.allServiceImages.push(im.Id)
        })

        this.allServices.push(element.ServiceRequestFormId)
      })
      for (let ServiceIterator of this.vendorInformation.ServiceRequestForms) {
        for (let questionIterator of ServiceIterator.ServiceRequestFormPrompts) {
          this.allserviceQuetions.push(
            questionIterator.ServiceRequestFormPromptId
          )
          for (let choicesIterator of questionIterator.ServiceRequestFormPromptChoices) {
            this.allservicechoices.push(choicesIterator.Id)
          }
        }
        for (let productIterator of ServiceIterator.ServiceRequestFormOptions) {
          this.allserviceproducts.push(productIterator.Id)
        }
      }
      console.log('this.allserviceproducts:', this.allserviceproducts)
      console.log('this.allserviceQuetions:', this.allserviceQuetions)
      console.log('this.allservicechoices:', this.allservicechoices)

      if (this.vendorInformation.ProviderMedias) {
        this.vendorInformation.ProviderMedias.forEach((media) => {
          this.allVendorImages.push(media.Id)
        })
      }

      this.vendorInformation.ProviderCategoryMappings.forEach((cat) => {
        this.allVendorCategory.push(cat.Id)
      })
    },
    // -------------------------------------------------------------------------------------------------------
    // User Permission to perform actions
    agreeFlagFunction(val) {
      if (val) {
        this.getRelevantInformation()
        this.deleteEnquiry_BLK()
          .then((response) => {
            this.deletionOfFacilityBuilding_BLK()
              .then((response1) => {
                console.log('closeYNPopup -> response1', response1)
                this.deletionOfImages_BLK()
                  .then((response2) => {
                    console.log('closeYNPopup -> response2', response2)
                    this.deleteofServiceproduct_BLK()
                      .then((productresponce) => {
                        console.log(
                          'closeYNPopup -> response2',
                          productresponce
                        )
                        this.deleteofChoices_BLK()
                          .then((choiceresponce) => {
                            console.log(
                              'closeYNPopup -> response2',
                              choiceresponce
                            )
                            this.deleteofQuestions_BLK()
                              .then((questionsresponce) => {
                                console.log(
                                  'closeYNPopup -> response2',
                                  questionsresponce
                                )
                                this.deleteService_BLK()
                                  .then((response3) => {
                                    console.log(
                                      'closeYNPopup -> response3',
                                      response3
                                    )
                                    this.deleteVendorMedia()
                                      .then((response4) => {
                                        console.log(
                                          'closeYNPopup -> response4',
                                          response4
                                        )
                                        this.deleteVendorCategory()
                                          .then((response5) => {
                                            console.log(
                                              'closeYNPopup -> response5',
                                              response5
                                            )
                                            this.deleteVendorFromDatabase(
                                              this.vendorIdForDeletion
                                            )
                                          })
                                          .catch(() => {
                                            this.loading = false
                                            this.postMessage =
                                              'Something went wrong. Please try again'
                                            this.showModal = true
                                          })
                                      })
                                      .catch(() => {
                                        this.loading = false
                                        this.postMessage =
                                          'Something went wrong. Please try again'
                                        this.showModal = true
                                      })
                                  })
                                  .catch(() => {
                                    this.postMessage =
                                      'Something went wrong. Please try again'
                                    this.loading = false
                                    this.showModal = true
                                  })
                              })
                              .catch(() => {
                                this.postMessage =
                                  'Something went wrong. Please try again'
                                this.loading = false
                                this.showModal = true
                              })
                          })
                          .catch(() => {
                            this.postMessage =
                              'Something went wrong. Please try again'
                            this.showModal = true
                            this.loading = false
                          })
                      })
                      .catch(() => {
                        this.postMessage =
                          'Something went wrong. Please try again'
                        this.showModal = true
                        this.loading = false
                      })
                  })
                  .catch(() => {
                    this.postMessage = 'Something went wrong. Please try again'
                    this.showModal = true
                    this.loading = false
                  })
              })
              .catch(() => {
                this.postMessage = 'Something went wrong. Please try again'
                this.showModal = true
                this.loading = false
              })
          })
          .catch(() => {
            this.postMessage = 'Something went wrong. Please try again'
            this.showModal = true
            this.loading = false
          })
      } else {
        this.sendResponseFalse()
      }
    },
    // -------------------------------------------------------------------------------------------------------
    // Function to Delete products associated with the services
    deleteofServiceproduct_BLK() {
      return new Promise(async (resolve, reject) => {
        if (this.allserviceproducts.length === 0) resolve('success')
        var i = 0

        for (let productID of this.allserviceproducts) {
          try {
            await this.deleteProductFromServiceProducts_BLK({
              Id: productID,
            })
            i = i + 1
            if (i === this.allserviceproducts.length) {
              resolve('success')
            }
          } catch (error) {
            reject(error)
          }
        }
      })
    },
    // -------------------------------------------------------------------------------------------------------
    // Function to Delete questions associated with the services
    deleteofQuestions_BLK() {
      return new Promise(async (resolve, reject) => {
        if (this.allserviceQuetions.length === 0) resolve('success')
        var i = 0

        for (let questionID of this.allserviceQuetions) {
          try {
            await this.deleteQuestionFromServiceQuestions_BLK({
              Id: questionID,
            })
            i = i + 1
            if (i === this.allserviceQuetions.length) {
              resolve('success')
            }
          } catch (error) {
            reject(error)
          }
        }
      })
    },
    // -------------------------------------------------------------------------------------------------------
    // Function to Delete choices associated with the services
    deleteofChoices_BLK() {
      return new Promise(async (resolve, reject) => {
        if (this.allservicechoices.length === 0) resolve('success')
        var i = 0
        for (let choiceId of this.allservicechoices) {
          try {
            await this.deleteChoiceFromServiceQuestions_BLK({
              Id: choiceId,
            })
            i = i + 1
            if (i === this.allservicechoices.length) {
              resolve('success')
            }
          } catch (error) {
            reject(error)
          }
        }
      })
    },
    // -------------------------------------------------------------------------------------------------------
    // Event triggered after Operation
    sendResponse() {
      if (this.vendorDeletedSuccessfully)
        this.$emit('servicesAndEnquiriesClose', true)
      else this.$emit('servicesAndEnquiriesClose', false)
    },
    sendResponseFalse() {
      this.$emit('servicesAndEnquiriesClose', false)
    },
  },
}
</script>
<style>
.headingText {
  font-family: JosefinSans-SemiBold;
  font-size: 15px;
  color: #959595;
}
.modal-mask {
  position: fixed;
  z-index: 9000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-width {
  padding: 20px;
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  border: 0px;
}
.padding-content {
  padding: 20px;
}
.modal-height {
  height: 100%;
  max-height: 400px;
  overflow-x: auto;
  padding-top: 0;
}
.modal-header {
  border-bottom: none;
}

.getFontBold {
  font-family: JosefinSans-Bold;
  font-size: 14px;
}
.close-btn {
  max-width: 100px;
  width: 100%;
}
.pd-l15 {
  padding-left: 15px;
}
.mr-t15 {
  margin-top: 15px;
}
.preview-header {
  /* justify-content: center; */
  padding: 0;
  display: inline;
  padding-left: 15px;
}
.text-css {
  text-align: justify;
  text-decoration: none;
  font-size: 16px !important;
  font-family: JosefinSans-SemiBold !important;
}
@media (max-width: 767px) {
  .text-css {
    text-align: justify;
  }
}
.modal-height::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.modal-height {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.getFontBold {
  font-family: JosefinSans-Bold;
  font-size: 14px;
}

.whtBtn {
  background-color: white;
  border: 1px solid black;
}

.deletePopup {
  padding: 10px !important;
}
@media (max-width: 576px) {
  .deletePopup {
    /* padding: 23px !important; */
    padding: 10px !important;
  }
}
.hideConfirm {
  display: none;
}
.customFont {
  font-family: JosefinSans-SemiBold;
  font-size: 14px;
}

h6 {
  font-family: 'JosefinSans-SemiBold' !important;
  font-size: 14px;
}
</style>
